'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jobsFilter = require('./jobs-filter.html');

var _jobsFilter2 = _interopRequireDefault(_jobsFilter);

var _jobsFilter3 = require('./jobs-filter.controller');

var _jobsFilter4 = _interopRequireDefault(_jobsFilter3);

require('./jobs-filter.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jobsFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template: _jobsFilter2.default,
  controller: _jobsFilter4.default,
  controllerAs: 'vm'
};

exports.default = jobsFilterComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/jobs-filter/jobs-filter.component.js
 **/